import { render } from "./DataPostViewPage.vue?vue&type=template&id=4f8b4505"
import script from "./DataPostViewPage.vue?vue&type=script&lang=js"
export * from "./DataPostViewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__